export const WHATSAPP_URL =
  "https://wa.me/523313607031?text=Hola%20Mariana%2C%20vi%20tu%20portafolio%20y%20me%20interesa%20un%20proyecto";

export const SITE_URL = "https://portfolio-mariana-ramirez-tech.netlify.app";
